/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_BulgarianInputs */



/**
* | output |
* | --- |
* | "Bulgarian" |
*
* @param {Speechmatics_Target_Language_BulgarianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_bulgarian = /** @type {((inputs?: Speechmatics_Target_Language_BulgarianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_BulgarianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bulgare")
	if (locale === "de") return /** @type {LocalizedString} */ ("bulgarisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("bulgaro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("болгарский")
	if (locale === "es") return /** @type {LocalizedString} */ ("búlgaro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保加利亚语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ブルガリア語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बल्गेरियाई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("búlgaro")
	return /** @type {LocalizedString} */ ("Bulgarian")
});